import * as Utils from "../Utils";
import FloodgateStorageProvider from "../FloodgateCore/FloodgateStorageProvider";
import { TargetedMessagingCache } from "../TargetedMessaging/TargetedMessagingCache";
import * as Logging from "../Logging/Logging";
const {
  isNOU
} = Utils;
let dynamicSettingsTmsgCache = null;
export function getDynamicSetting(key, defaultValue) {
  try {
    if (!dynamicSettingsTmsgCache && FloodgateStorageProvider.isStorageAvailable()) {
      dynamicSettingsTmsgCache = new TargetedMessagingCache(["DynamicSettings" /* dynamicSettings */]);
    }
    if (!dynamicSettingsTmsgCache) {
      return defaultValue;
    }
    const settingsObj = dynamicSettingsTmsgCache.getItemContent("DynamicSettings" /* dynamicSettings */);
    if (!isNOU(settingsObj) && settingsObj.hasOwnProperty(key) && !isNOU(settingsObj[key])) {
      const settingValue = settingsObj[key];
      // parse types
      if (typeof defaultValue === "number" && typeof settingValue !== "number") {
        if (typeof settingValue === "string") {
          const returnValue = settingValue.indexOf(".") === -1 ? parseInt(settingValue, 10) : parseFloat(settingValue);
          return isNaN(returnValue) ? defaultValue : returnValue;
        }
        return defaultValue;
      }
      return settingValue;
    }
  } catch (error) {
    Logging.getLogger().logEvent(Logging.EventIds.Common.Error.VALUE, 2 /* Error */, {
      ErrorMessage: `Error reading dynamic setting ${error && error.message}`,
      Type: key
    });
  }
  return defaultValue;
}
export function resetDynamicSettingsTmsgCache() {
  dynamicSettingsTmsgCache = null;
}